var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Divider from '../Dividers/Divider';
var TextFieldDivider = function (_PureComponent) {
  _inherits(TextFieldDivider, _PureComponent);
  function TextFieldDivider() {
    _classCallCheck(this, TextFieldDivider);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  TextFieldDivider.prototype.render = function render() {
    var _props = this.props,
      active = _props.active,
      error = _props.error,
      lineDirection = _props.lineDirection,
      className = _props.className,
      props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);
    return React.createElement(Divider, _extends({}, props, {
      className: cn('md-divider--text-field md-divider--expand-from-' + lineDirection, {
        'md-divider--text-field-expanded': active,
        'md-divider--text-field-active': !error && active,
        'md-divider--text-field-error': error
      }, className)
    }));
  };
  return TextFieldDivider;
}(PureComponent);
TextFieldDivider.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  active: PropTypes.bool,
  error: PropTypes.bool,
  lineDirection: PropTypes.oneOf(['left', 'center', 'right'])
};
export default TextFieldDivider;